import { produccionRetiroApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'PRODUCCION-RETIRO',
    api: produccionRetiroApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'PRODUCCION-RETIRO',
  api: produccionRetiroApi,
  relUrl: '',
});

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'PRODUCCION-RETIRO',
    api: produccionRetiroApi,
    relUrl: `indexByParent/${id}`,
  });

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'PRODUCCION-RETIRO',
    api: produccionRetiroApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'PRODUCCION-RETIRO',
    api: produccionRetiroApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'PRODUCCION-RETIRO',
  api: produccionRetiroApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'PRODUCCION-RETIRO',
    api: produccionRetiroApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('PRODUCCION-RETIRO');
export const setDeletedPending =
  createListDataDeletedPending('PRODUCCION-RETIRO');
